'use client';

import { useMemo, useState } from 'react';
import { NavigationContext } from './contexts/NavigationContext';
import { Level } from '../utils/constants';

export type NavigationContextProviderProps = {
  children: React.ReactNode;
  defaultSection: string | null;
};

export const NavigationContextProvider = ({ children, defaultSection }: NavigationContextProviderProps) => {
  const [section, setSection] = useState<string | null>(defaultSection);
  const [level, setLevel] = useState<Level>(Level.Group);
  const [isFinishButtonDisabled, setIsFinishButtonDisabled] = useState<boolean>(false);
  const contextValue = useMemo(() => {
    return {
      section,
      setSection,
      level,
      setLevel,
      isFinishButtonDisabled,
      setIsFinishButtonDisabled,
    };
  }, [section, level, isFinishButtonDisabled]);

  return <NavigationContext.Provider value={contextValue}>{children}</NavigationContext.Provider>;
};
